import { schema } from 'normalizr';

const feedbackCommentSchema = new schema.Entity('feedbackComments', {});

export default feedbackCommentSchema;
